import { Badge } from '@commenda/kakashi';
import { TSysAgentStepDefinition } from '@commenda/types';
import { Handle, Position } from '@xyflow/react';
import { WorkflowHandlerID } from '../../workflow/ui';
import { useWorkflow } from '../context/WorkflowContext';
import { TNodeProps } from '../types/node';
import { BaseNode } from './BaseNode';
import { SOURCE_HANDLE_CLASSNAME, TARGET_HANDLE_CLASSNAME } from './helpers';

export const AgentNode = (props: TNodeProps) => {
  const { data } = props;
  const { workflow } = useWorkflow();

  const selectedStep = workflow?.steps.find((step) => step.id === data.id) as
    | TSysAgentStepDefinition
    | undefined;

  // `readOnly` is the only tool-access field the bridge reads. Absent defaults closed.
  const canWrite = selectedStep?.readOnly === false;

  return (
    <BaseNode {...props} className="min-w-80">
      {canWrite && (
        <div className="px-lg pb-md">
          <Badge variant="warning" size="sm">
            This step can change data
          </Badge>
        </div>
      )}
      <Handle
        type="source"
        position={Position.Right}
        className={SOURCE_HANDLE_CLASSNAME}
        id={WorkflowHandlerID.SOURCE_RIGHT}
      />
      <Handle
        type="target"
        position={Position.Left}
        className={TARGET_HANDLE_CLASSNAME}
        id={WorkflowHandlerID.TARGET_LEFT}
      />
      <Handle
        type="source"
        position={Position.Top}
        className={SOURCE_HANDLE_CLASSNAME}
        id={WorkflowHandlerID.SOURCE_TOP}
        style={{ left: '54%' }}
      />
      <Handle
        type="target"
        position={Position.Top}
        className={TARGET_HANDLE_CLASSNAME}
        id={WorkflowHandlerID.TARGET_TOP}
        style={{ left: '46%' }}
      />
      <Handle
        type="source"
        position={Position.Bottom}
        className={SOURCE_HANDLE_CLASSNAME}
        id={WorkflowHandlerID.SOURCE_BOTTOM}
        style={{ left: '54%' }}
      />
      <Handle
        type="target"
        position={Position.Bottom}
        className={TARGET_HANDLE_CLASSNAME}
        id={WorkflowHandlerID.TARGET_BOTTOM}
        style={{ left: '46%' }}
      />
    </BaseNode>
  );
};
